import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbNavProps {
  items: BreadcrumbItem[];
}

export default function BreadcrumbNav({ items }: BreadcrumbNavProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-6 md:px-10 lg:px-16 py-4">
      <ol className="flex items-center flex-wrap gap-1 text-xs text-foreground-500">
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center">
            {idx > 0 && (
              <span className="mx-2 text-foreground-300">/</span>
            )}
            {item.href && idx < items.length - 1 ? (
              <Link
                to={item.href}
                className="hover:text-accent-500 transition-colors duration-200 whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className={idx === items.length - 1 ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}